<div class="field is-grouped is-grouped-multiline custom-tags">
  <div class="control" *ngFor="let tag of tags">
    <span class="tag is-info my-tag-margin">{{ tag }}</span>
  </div>
</div>
